// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__3zLBQ","title":"styles_title__12yoA","content":"styles_content__3quVU","collapsed":"styles_collapsed__29S4v"};